import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import LoginForm from '../../pages/auth/components/LoginForm'
import { AlertLoginFailed } from '../alerts/AlertLoginFailed'
import { useEffect, useState } from 'react'
import LocalSideNavigation from '../../pages/localSideNavigation/LocalSideNavigation'
import { ErrorBoundary } from '../../pages/error/ErrorBoundary'
import { useAuth } from '../authContext/utils'

const PageLayout = () => {
  const auth = useAuth()
  const navigate = useNavigate()
  const location = useLocation()
  const [previousPath, setPreviousPath] = useState<string>('/')
  const [collapsed, setCollapsed] = useState(false)

  useEffect(() => {
    if (location.pathname !== '/login') {
      setPreviousPath(location.pathname)
    }
    if (!auth.isAuthenticated && !auth.hasExistingSession) {
      navigate('/login', { state: { from: { pathname: previousPath } } })
    }
    if (auth.isAuthenticated && location.pathname === '/login') {
      navigate(previousPath)
    }
  }, [auth.isAuthenticated, navigate, location.pathname, previousPath, auth.hasExistingSession])
  
  if (!auth.isAuthenticated && !auth.hasExistingSession) {
    return (
      <>
        {auth.isVisibleLoginFailedAlert && <AlertLoginFailed />}
        <LoginForm />
      </>
    )
  }

  return (
    <>
      <LocalSideNavigation
        collapsed={collapsed}
        setCollapsed={setCollapsed}
      />
      <div style={{ paddingLeft: collapsed ? '4rem' : '15rem' }}>
        <ErrorBoundary location={location}>
          <Outlet />
        </ErrorBoundary>
      </div>
    </>
  )
}

export { PageLayout }
